import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { config } from './api/api';

const PaymentLoading = () => {
  const [loadingText, setLoadingText] = useState('Processing');
  const location = useLocation();
  const navigate = useNavigate();
  const lnstr = Cookies.get('langData') || 'en';

  const texts = lnstr === 'en' 
    ? ['Processing', 'Loading...', 'Please wait', 'Almost done']
    : ['جاري المعالجة', 'جاري التحميل...', 'يرجى الانتظار', 'تم تقريباً'];

  useEffect(() => {
 
    const urlParams = new URLSearchParams(location.search);
    const brParam = urlParams.get('br');
    if(!brParam || (brParam === '' || brParam === 'null')) {
      return;
    }
    const timer = setTimeout(() => {
      window.location.href = `${config.baseURL}/motorpaymentsstatus?br=${brParam}`;
    }, 5000);

    return () => clearTimeout(timer);
  }, [location.search, navigate]);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingText(prev => {
        const currentIndex = texts.indexOf(prev);
        return texts[(currentIndex + 1) % texts.length];
      });
    }, 1500);

    return () => clearInterval(interval);
  }, [texts]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f8f9fa',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        width: '300px',
        textAlign: 'center'
      }}>
        <h3 style={{
          color: '#333',
          marginBottom: '30px',
          fontSize: '24px'
        }}>
          {loadingText}
        </h3>
        
        <div style={{
          width: '100%',
          height: '6px',
          backgroundColor: '#e0e0e0',
          borderRadius: '3px',
          overflow: 'hidden',
          marginBottom: '20px'
        }}>
          <div style={{
            height: '100%',
            background: 'linear-gradient(90deg, #007bff, #0056b3)',
            borderRadius: '3px',
            animation: 'loading 2s ease-in-out infinite'
          }} />
        </div>

        <p style={{
          color: '#666',
          fontSize: '14px',
          margin: 0
        }}>
          {lnstr === 'en' ? 'Do not refresh or close this page' : 'لا تقم بتحديث أو إغلاق هذه الصفحة'}
        </p>
      </div>

      <style jsx>{`
        @keyframes loading {
          0% {
            transform: translateX(-100%);
          }
          50% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </div>
  );
};

export default PaymentLoading;